import React from 'react';
import { motion } from 'framer-motion';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { skillGroups } from '../data/profile';
export function Skills() {
  return <PageShell path="/skills" data-id="element-358" data-mp="96cril7285cl">
      <section className="bg-white py-20 lg:py-24" aria-labelledby="skills-heading" data-id="element-359" data-mp="46rj7k602kn7">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-360" data-mp="48ufun1nrc0w">
          <div id="skills-heading" data-id="element-361" data-mp="11t728qe2rqcv">
            <SectionHeading eyebrow="Executive Capability" title="Skills, and the depth of practice behind them" description="Leadership and human capabilities only. Platforms, frameworks and tooling are covered in Section 08." data-id="element-362" data-mp="11wcrc5mpes8l" />
          </div>

          <div className="mt-14 space-y-14" data-id="element-363" data-mp="n3rms6jzv7ch">
            {skillGroups.map(group => <div key={group.title} className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-16" data-id="element-364" data-mp="1kn2uzwk3mj2i">
                <div className="lg:col-span-4" data-id="element-365" data-mp="1fs6ppupupz7g">
                  <h3 className="font-display text-xl font-bold tracking-tight text-navy-900" data-id="element-366" data-mp="64bv3fgb8qhr">
                    {group.title}
                  </h3>
                  <p className="mt-3 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-367" data-mp="b5rivf9vhb3u">
                    {group.intent}
                  </p>
                </div>

                <ul className="space-y-7 border-t border-platinum-200 pt-7 lg:col-span-8 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-368" data-mp="1camc3icphwh">
                  {group.skills.map(skill => <li key={skill.name} data-id="element-369" data-mp="3nm4qoh23ivz4">
                      <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1" data-id="element-370" data-mp="3niqq9eczswub">
                        <p className="font-display text-base font-semibold text-navy-900" data-id="element-371" data-mp="39nnb56mcgpsa">
                          {skill.name}
                        </p>
                        <p className="font-sans text-xs text-charcoal-600" data-id="element-372" data-mp="17v8t87jsvlbv">{skill.note}</p>
                      </div>
                      <div className="mt-3 h-1.5 w-full bg-platinum-200" role="img" aria-label={`${skill.name}: ${skill.level} out of 100 depth of practice`} data-id="element-373" data-mp="1cs90umwasw53">
                        <motion.div initial={{
                    scaleX: 0
                  }} whileInView={{
                    scaleX: skill.level / 100
                  }} viewport={{
                    once: true,
                    amount: 0.6
                  }} transition={{
                    duration: 0.3,
                    ease: [0.23, 1, 0.32, 1]
                  }} style={{
                    transformOrigin: 'left'
                  }} className="h-full bg-gold-500" data-id="element-374" data-mp="11d5qy1k6i4ku" />
                      </div>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>
    </PageShell>;
}